<mat-card class="triton-card">
   <ng-content></ng-content>
</mat-card>
